import { IUser } from "../../../../types/user/iuser.interface";
import { TRow } from "../listing-table.types";
import { getUserFullName } from "../../../../features/user/types/user.functions";

export const UserName = (user: IUser | TRow) => getUserFullName(user as IUser);
